<template>
  <div>
    <PrintScheme  :printIds="ids"/>
  </div>
</template>

<script>
import PrintScheme from '@/components/DownLoadAndPrint/v2/Scheme.vue'

export default {
  components: { PrintScheme },
  data () {
    return {
      ids: this.$route.query.ids
    }
  }
}
</script>
